import { IControl } from "../icontrol";
import { ControlType } from "../../controltype";
import { RadioIEnumValue } from './ienumvalue';

/**
 * 多选组控件
 */
export class RadioControl implements IControl{

    /**
     * 获取控件类型
     */
    getControlType(): ControlType {
        return ControlType.Radio;
    }

    /**
     * 多选组数据源列表
     */
    enumValues:Array<RadioIEnumValue>;
    /**
     * 是否是展示在扩展区域内的
     */
    isExtend:boolean;

    /**是否显示label */
    showLabel:boolean;
    /**是否必填 */
    required:boolean;
}